"use client";
import Image from "next/image";
import checked2 from "@/assets/checked2.svg";
export default function TrustBadges() {
  const trustBadges = [
    {
      id: 1,
      content: (
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0">
            <Image src={checked2} alt="Checked" width={20} height={20} />
          </div>
          <div>
            <p className="text-gray-900">
              <span className="font-bold">UK-registered</span> prescribers
            </p>
          </div>
        </div>
      ),
    },
    {
      id: 2,
      content: (
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0">
            <Image src={checked2} alt="Checked" width={20} height={20} />
          </div>
          <div>
            <p className="text-gray-900">
              Fully regulated <span className="font-bold">U.K. clinic</span>
            </p>
          </div>
        </div>
      ),
    },
    {
      id: 3,
      content: (
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0">
            <Image src={checked2} alt="Checked" width={20} height={20} />
          </div>
          <div>
            <p className="text-gray-900">
              <span className="font-bold">5.0</span> over{" "}
              <span className="font-bold">25,000 reviews</span>
            </p>
          </div>
        </div>
      ),
    },
  ];

  return (
    <section className="bg-white py-8">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Mobile Marquee */}
        <div className="block md:hidden overflow-hidden">
          <div className="flex animate-marquee whitespace-nowrap">
            {Array.from({ length: 6 }, (_, i) =>
              trustBadges.map((badge) => (
                <div
                  key={`${badge.id}-${i}`}
                  className="flex-shrink-0 mx-4 flex justify-center"
                >
                  {badge.content}
                </div>
              )),
            )}
          </div>
        </div>

        {/* Desktop Grid */}
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-6">
          {trustBadges.map((badge) => (
            <div key={badge.id} className="flex justify-center">
              {badge.content}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
